/**
 * EasyGo Pet Carrier 产品图片切换系统
 * 根据三个属性(Handle Color, Body Color, Strap Color)动态切换产品图片
 */

(function() {
  'use strict';

  console.log('🔧 [EasyGo] 脚本开始加载...');

  // ========== 配置 ==========
  // 支持多个产品名称变体
  const PRODUCT_NAMES = [
    'EasyGo Pet Carrier',
    'EasyGo Pet Carrier (without Collar)',
    'EasyGo Pet Carrier (WITHOUT Collar)'
  ];
  const CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const CDN_VERSION = '?v=1763954811';

  // 🎯 已上传到 CDN 的图片（Pink/Blue/Brown Body + White Strap 组合）
  const AVAILABLE_CDN_IMAGES = [
    // Pink Body + White Strap
    'babyblue_pink_white',
    'babypink_pink_white',
    'blue_pink_white',
    'cyan_pink_white',
    'navyblue_pink_white', // 新增 Navy Blue
    'pink_pink_white',
    'purple_pink_white',
    'white_pink_white',
    'yellow_pink_white',
    
    // Blue Body + White Strap
    'babyblue_blue_white',
    'babypink_blue_white',
    'cyan_blue_white',
    'navyblue__blue_white', // 注意：截图显示有两个下划线
    'pink_blue_white',
    'purple_blue_white',
    'white_blue_white',
    'yellow_blue_white',
    
    // Brown Body + White Strap
    'babyblue_brown_white',
    'babypink_brown_white',
    'cyan_brown_white',
    'navyblue_brown_white',
    'pink_brown_white',
    'purple_brown_white',
    'white_brown_white',
    'yellow_brown_white'
  ];

  // 颜色名称映射(产品选项名称 -> 文件名)
  const COLOR_NAME_MAP = {
    // Handle Colors
    'BabyBlue': 'babyblue',
    'Baby Blue': 'babyblue',
    'BabyPink': 'babypink',
    'Baby Pink': 'babypink',
    'Blue': 'blue',
    'Cyan': 'cyan',
    'Pink': 'pink',
    'Purple': 'purple',
    'White': 'white',
    'Yellow': 'yellow',
    'AccoYellow': 'yellow',
    'Orange': 'orange',
    'Black': 'black',
    'Green': 'green',
    'Red': 'red',
    'Brown': 'brown',
    'NavyBlue': 'navyblue',
    'Navy Blue': 'navyblue'
  };

  // 颜色代码映射(用于显示颜色球)
  const COLOR_CODE_MAP = {
    'BabyBlue': '#A7C6ED',
    'BabyPink': '#FFB6D9',
    'Blue': '#2A6EBB',
    'Cyan': '#00CED1',
    'Pink': '#EEC3D7',
    'Purple': '#9B59B6',
    'White': '#FFFFFF',
    'Yellow': '#FFD93D',
    'Orange': '#E49B2A',
    'Black': '#000000',
    'Green': '#27AE60',
    'Red': '#E03C31',
    'Brown': '#8B5B29',
    'NavyBlue': '#001F3F'
  };

  // ========== 工具函数 ==========
  
  // 检测是否在 customize 构建器页面
  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  function isDesktopPdpWith2x2() {
    const main = document.querySelector('.main-image');
    if (!main || !main.querySelector('.product-media-2x2')) return false;
    return window.matchMedia('(min-width: 768px)').matches;
  }

  // 检查是否应该运行(只对 EasyGo Pet Carrier 启用)
  // 使用静态变量记录是否已经输出过不匹配日志，避免重复输出
  let hasLoggedMismatch = false;
  let lastCheckedProduct = '';
  
  function shouldRun() {
    // 排除 Valentine 产品
    const path = window.location.pathname.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    if (/valentine|情人节/.test(path + ' ' + pageTitle)) {
      return false;
    }

    // 目标产品的 handle 列表（含 SEO 改动后的 handle）
    const TARGET_HANDLES = [
      'easygo-pet-carrier',
      'pet-carrier-easygo',
      'easygo',
      'custom-pet-carrier',
      'customizable-pet-carrier'
    ];

    // Customize 页面
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = selectedOption.value; // 获取 handle

          if (selectedHandle.includes('detachable-handle') || /detachable handle pair/i.test(selectedName)) {
            return false;
          }

          // 检查名称或 handle 是否匹配
          // 🎯 使用多个产品名称匹配，或使用 includes 匹配
          const nameMatch = PRODUCT_NAMES.some(name => selectedName === name) || 
                           (selectedName.includes('EasyGo') && selectedName.includes('Carrier') && !selectedName.includes('Outdoor') && !/detachable handle|handle pair/i.test(selectedName)) ||
                           (selectedName.includes('Customizable') && selectedName.includes('Pet Carrier')) ||
                           (selectedName.includes('Custom') && selectedName.includes('Pet Carrier'));
          const handleMatch = TARGET_HANDLES.some(h => selectedHandle.includes(h));

          if (nameMatch || handleMatch) {
            console.log('✅ [EasyGo] Customize页面匹配:', selectedName, '| Handle:', selectedHandle);
            hasLoggedMismatch = false; // 重置标记
            lastCheckedProduct = selectedName;
            return true;
          } else {
            // 🎯 只在产品切换时或第一次检查时输出日志，避免重复
            if (!hasLoggedMismatch || lastCheckedProduct !== selectedName) {
              console.log('⏭️  [EasyGo] Customize页面产品不匹配:', selectedName);
              hasLoggedMismatch = true;
              lastCheckedProduct = selectedName;
            }
          }
        }
      }
      return false;
    }

    // 普通产品页面:只检查 URL（更严格的检查）
    const url = window.location.href.toLowerCase();

    // 🎯 排除 AccoGift EasyGo Pet Outdoor Set / Pet Travel Gift Set（由 product-easygo-outdoor-set.js 处理）
    if ((url.includes('accogift') && (url.includes('outdoor-set') || url.includes('outdoor set'))) ||
        (pageTitle.includes('accogift') && (pageTitle.includes('outdoor set') || pageTitle.includes('outdoor-set')))) {
      console.log('⏭️  [EasyGo] 跳过 AccoGift EasyGo Pet Outdoor Set（由其他脚本处理）');
      return false;
    }
    if (url.includes('pet-travel-gift-set') || pageTitle.includes('pet travel gift set')) {
      console.log('⏭️  [EasyGo] 跳过 Pet Travel Gift Set（由 outdoor-set 脚本处理）');
      return false;
    }

    if (url.includes('detachable-handle') || /detachable handle pair|detachable handle/i.test(pageTitle)) {
      console.log('⏭️  [EasyGo] 跳过 Detachable Handle Pair（非三选项 Carrier，由 product-pdp-2x2-variant-sync 同步变体图）');
      return false;
    }

    // 只有当 URL 或标题中明确包含 easygo 且不是 Outdoor Set 才运行
    const hasEasyGo = (url.includes('easygo') || pageTitle.includes('easygo')) && 
                      !url.includes('outdoor-set') && 
                      !pageTitle.includes('outdoor set');
    
    if (hasEasyGo) {
      console.log('✅ [EasyGo] 产品页面匹配 (URL/标题包含 easygo)');
      return true;
    }

    // 如果URL中包含产品的 handle（含 customizable-* 等 SEO URL，不含已在上面排除的 gift/outdoor）
    const productHandles = [
      'easygo-pet-carrier',
      'pet-carrier-easygo',
      'custom-pet-carrier',
      'customizable-pet-carrier'
    ];
    const hasHandle = productHandles.some(handle => url.includes(handle));
    
    if (hasHandle) {
      console.log('✅ [EasyGo] 产品页面匹配 (URL包含产品handle)');
      return true;
    }

    return false;
  }

  // 标准化颜色名称(转换为文件名格式)
  function normalizeColorName(colorName) {
    if (!colorName) return null;

    // 先查找映射表
    if (COLOR_NAME_MAP[colorName]) {
      return COLOR_NAME_MAP[colorName];
    }

    // 清理并转小写
    const normalized = colorName
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-z]/g, '');

    // 再次查找映射表(使用清理后的名称)
    const keys = Object.keys(COLOR_NAME_MAP);
    for (const key of keys) {
      const keyNormalized = key.toLowerCase().replace(/\s+/g, '');
      if (keyNormalized === normalized) {
        return COLOR_NAME_MAP[key];
      }
    }

    console.warn('⚠️  [EasyGo] 未找到颜色映射:', colorName);
    return normalized;
  }

  // 生成图片 URL
  function generateImageUrl(handleColor, bodyColor, strapColor) {
    const handle = normalizeColorName(handleColor);
    const body = normalizeColorName(bodyColor);
    const strap = normalizeColorName(strapColor);

    if (!handle || !body || !strap) {
      console.warn('⚠️  [EasyGo] 颜色值不完整:', { handleColor, bodyColor, strapColor });
      return null;
    }

    const filenameBase = `${handle}_${body}_${strap}`;
    
    // 🎯 验证这个组合是否在已上传的 CDN 图片列表中
    let finalFilename = filenameBase;
    if (!AVAILABLE_CDN_IMAGES.includes(filenameBase)) {
      // 尝试查找可能的替代命名（比如 navyblue__blue_white）
      const alternativeName = `${handle}__${body}_${strap}`;
      if (AVAILABLE_CDN_IMAGES.includes(alternativeName)) {
        console.log(`🔧 [EasyGo] 找到替代文件名: ${alternativeName}`);
        finalFilename = alternativeName;
      } else {
        console.error('❌ [EasyGo] 该颜色组合的图片未上传到 CDN:', filenameBase);
        console.log('📋 [EasyGo] 可用的 CDN 图片:', AVAILABLE_CDN_IMAGES);
        return null;
      }
    }
    
    const filename = `${finalFilename}.png`;
    const url = `${CDN_BASE_URL}${filename}${CDN_VERSION}`;

    console.log('🔧 [EasyGo] 生成图片URL:', url);
    return url;
  }

  // ========== 主要功能 ==========

  // 防抖计时器
  let updateTimer = null;
  let isUpdating = false;
  let lastCarrierUpdateKey = '';
  let overlayVisible = true;

  /**
   * 与 product-easygo-outdoor-set.js 一致：PDP 用 Globo / option1–3；Customize 用 swatch / text-option / select。
   */
  function getOptionValue(index) {
    if (isCustomizePage()) {
      if (typeof window.selectedOptions !== 'undefined' && window.selectedOptions && index < window.selectedOptions.length) {
        const value = window.selectedOptions[index];
        if (value) return value;
      }
      const swatch = document.querySelector(`.color-swatch[data-index="${index}"].selected`);
      if (swatch) return swatch.dataset.value;
      const textBtn = document.querySelector(`.text-option[data-index="${index}"].selected`);
      if (textBtn) return textBtn.dataset.value;
      const select = document.querySelector(`select[data-index="${index}"]`);
      if (select && select.value) return select.value;
      return null;
    }
    const globo = document.querySelector(`input[name="globo-option-${index}"]:checked`);
    if (globo) return globo.value;
    const idx = index + 1;
    const std = document.querySelector(`input[name*="option${idx}"]:checked, input[name*="Option${idx}"]:checked`);
    if (std) return std.value;
    const stdSelect = document.querySelector(`select[name*="option${idx}"], select[name*="Option${idx}"]`);
    if (stdSelect && stdSelect.value) return stdSelect.value;
    return null;
  }

  function setDesktop2x2VariantCellImage(imageUrl, onDone) {
    if (!imageUrl) {
      if (onDone) onDone();
      return;
    }
    const cell = document.querySelector('.product-media-2x2 .media-2x2-cell--variant');
    let vImg = cell && cell.querySelector('img');
    if (cell && !vImg) {
      vImg = document.createElement('img');
      vImg.alt = '';
      cell.appendChild(vImg);
    }
    if (!vImg) {
      if (onDone) onDone();
      return;
    }
    const testImg = new Image();
    testImg.onload = function () {
      if (vImg.hasAttribute('srcset')) vImg.removeAttribute('srcset');
      if (vImg.hasAttribute('sizes')) vImg.removeAttribute('sizes');
      vImg.loading = 'eager';
      vImg.src = imageUrl;
      console.log('✅ [EasyGo] 桌面 2×2：右上变体格已写入 CDN 图');
      if (onDone) onDone();
    };
    testImg.onerror = function () {
      console.error('❌ [EasyGo] 桌面 2×2 变体格图片加载失败:', imageUrl);
      if (onDone) onDone();
    };
    testImg.src = imageUrl;
  }

  function syncCarrierOverlayLayout() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    const overlay = mainImageContainer.querySelector('.easygo-carrier-overlay');
    if (!overlay) return;
    overlay.style.top = '0';
    overlay.style.bottom = '0';
    overlay.style.left = '0';
    overlay.style.right = '0';
    overlay.style.width = '';
  }

  function getOrCreateCarrierOverlay() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return null;
    let overlay = mainImageContainer.querySelector('.easygo-carrier-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'easygo-carrier-overlay';
      overlay.style.cssText =
        'position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;background-color:#fff;z-index:100;pointer-events:none;';
      const img = document.createElement('img');
      img.className = 'easygo-carrier-overlay-image';
      img.style.cssText =
        'max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;';
      overlay.appendChild(img);
      mainImageContainer.style.position = 'relative';
      mainImageContainer.appendChild(overlay);
      console.log('✅ [EasyGo] 创建覆盖层');
    }
    syncCarrierOverlayLayout();
    return overlay;
  }

  function showCarrierOverlay() {
    if (isCustomizePage()) return;
    if (isDesktopPdpWith2x2()) {
      hideCarrierOverlay();
      return;
    }
    const overlay = getOrCreateCarrierOverlay();
    if (overlay) {
      syncCarrierOverlayLayout();
      overlay.style.display = 'flex';
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
      overlayVisible = true;
    }
  }

  function hideCarrierOverlay() {
    if (isCustomizePage()) return;
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    const overlay = mainImageContainer.querySelector('.easygo-carrier-overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.visibility = 'hidden';
      overlay.style.opacity = '0';
      overlayVisible = false;
    }
  }

  function updateCarrierOverlayImage(imageUrl) {
    if (!isCustomizePage() && isDesktopPdpWith2x2()) {
      setDesktop2x2VariantCellImage(imageUrl, function () {
        isUpdating = false;
      });
      return;
    }
    const overlay = getOrCreateCarrierOverlay();
    if (!overlay) {
      isUpdating = false;
      return;
    }
    const img = overlay.querySelector('.easygo-carrier-overlay-image');
    if (!img) {
      isUpdating = false;
      return;
    }
    const testImg = new Image();
    testImg.onload = function () {
      img.src = imageUrl;
      showCarrierOverlay();
      isUpdating = false;
      console.log('✅ [EasyGo] 覆盖层图片已更新');
    };
    testImg.onerror = function () {
      console.error('❌ [EasyGo] 覆盖层图片加载失败:', imageUrl);
      showImageError('This color combination image is not available yet.');
      isUpdating = false;
    };
    testImg.src = imageUrl;
  }

  function isFirstSlideActive() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return false;
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    return !!(firstSliderItem && firstSliderItem.classList.contains('is-active'));
  }

  function switchToFirstSlide() {
    if (isCustomizePage()) return;
    if (isDesktopPdpWith2x2()) {
      hideCarrierOverlay();
      return;
    }
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    if (!firstSliderItem || firstSliderItem.classList.contains('is-active')) {
      showCarrierOverlay();
      return;
    }
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && firstSliderItem.dataset.mediaId && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(firstSliderItem.dataset.mediaId, true);
      setTimeout(showCarrierOverlay, 100);
      return;
    }
    const firstThumbnail = document.querySelector('.thumbnails .slider__item:first-child .thumbnail');
    if (firstThumbnail) {
      firstThumbnail.click();
      setTimeout(showCarrierOverlay, 100);
    }
  }

  function handleCarrierThumbnailClick(e) {
    if (!shouldRun() || isCustomizePage()) return;
    const thumbnail = e.target.closest('.thumbnail');
    if (!thumbnail) return;
    const sliderItem = thumbnail.closest('.slider__item');
    if (!sliderItem) return;
    hideCarrierOverlay();
  }

  function handleCarrierCarouselSlide() {
    if (!shouldRun() || isCustomizePage()) return;
    hideCarrierOverlay();
  }

  // Customize：按 label 映射的选项索引读颜色球（PDP 用 getOptionValue）
  function getCurrentColor(optionIndex) {
    const customSwatches = document.querySelectorAll(`.color-swatch[data-index="${optionIndex}"]`);
    if (customSwatches.length > 0) {
      const selectedSwatch = [...customSwatches].find(function (swatch) {
        return swatch.classList.contains('selected');
      });
      if (selectedSwatch) return selectedSwatch.dataset.value;
    }
    return null;
  }

  function getCarrierColorsForUpdate() {
    if (isCustomizePage()) {
      const ix = getOptionIndices();
      return {
        handleColor: getCurrentColor(ix.handle),
        bodyColor: getCurrentColor(ix.body),
        strapColor: getCurrentColor(ix.strap)
      };
    }
    return {
      handleColor: getOptionValue(0),
      bodyColor: getOptionValue(1),
      strapColor: getOptionValue(2)
    };
  }

  function resolveCarrierCdnUrl(handleColor, bodyColor, strapColor) {
    let url = generateImageUrl(handleColor, bodyColor, strapColor);
    if (!url) url = buildStandardCarrierCdnUrl(handleColor, bodyColor, strapColor);
    return url;
  }

  function updateCustomizeCarrierCdnImage(handleColor, bodyColor, strapColor) {
    const cdnUrl = resolveCarrierCdnUrl(handleColor, bodyColor, strapColor);
    if (!cdnUrl) {
      const currentVariant = getCurrentVariant();
      if (currentVariant && currentVariant.featured_image) {
        const variantImage = currentVariant.featured_image.src;
        document.querySelectorAll('.custom-builder .main-image, #product-link .main-image, .product-image .main-image').forEach(function (img) {
          if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
          if (img.hasAttribute('sizes')) img.removeAttribute('sizes');
          img.src = variantImage;
        });
      }
      isUpdating = false;
      return;
    }
    const img =
      document.querySelector('.custom-builder .main-image') ||
      document.querySelector('#product-link .main-image') ||
      document.querySelector('.product-image .main-image');
    if (!img) {
      isUpdating = false;
      return;
    }
    const testImg = new Image();
    testImg.onload = function () {
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (img.hasAttribute('sizes')) img.removeAttribute('sizes');
      img.loading = 'eager';
      img.src = cdnUrl;
      isUpdating = false;
    };
    testImg.onerror = function () {
      showImageError('This color combination image is not available yet.');
      isUpdating = false;
    };
    testImg.src = cdnUrl;
  }

  // 获取当前选中的 variant 数据（仅 Customize 页面）
  function getCurrentVariant() {
    if (!isCustomizePage()) return null;

    // 从全局变量中获取当前 variant
    if (window.currentEasyGoVariant) {
      return window.currentEasyGoVariant;
    }

    return null;
  }

  // 更新产品图片（带防抖，与 outdoor-set 一致）
  function updateProductImage() {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(doUpdateProductImage, 300);
  }

  // Customize：选项索引映射（PDP 用 getOptionValue(0/1/2)）
  function getOptionIndices() {
    const indices = {
      handle: 0,
      body: 1,
      strap: 2
    };
    const groups = document.querySelectorAll('#product-option-groups .color-swatches');
    groups.forEach(function (group, index) {
      const label = group.previousElementSibling;
      if (label && label.tagName === 'LABEL') {
        const text = label.textContent.toLowerCase();
        if (text.includes('handle')) indices.handle = index;
        else if (text.includes('body')) indices.body = index;
        else if (text.includes('strap') || text.includes('leash')) indices.strap = index;
      }
    });
    console.log('🔧 [EasyGo] Customize 选项索引:', indices);
    return indices;
  }

  /** 不校验白名单；generateImageUrl 失败时作兜底 URL */
  function buildStandardCarrierCdnUrl(handleColor, bodyColor, strapColor) {
    const handle = normalizeColorName(handleColor);
    const body = normalizeColorName(bodyColor);
    const strap = normalizeColorName(strapColor);
    if (!handle || !body || !strap) return null;
    return `${CDN_BASE_URL}${handle}_${body}_${strap}.png${CDN_VERSION}`;
  }

  function doUpdateProductImage() {
    console.log('🔧 [EasyGo] doUpdateProductImage');
    if (!shouldRun()) return;

    if (isUpdating) {
      console.log('⏭️  [EasyGo] 正在更新中，跳过');
      return;
    }

    const colors = getCarrierColorsForUpdate();
    const handleColor = colors.handleColor;
    const bodyColor = colors.bodyColor;
    const strapColor = colors.strapColor;

    console.log('🔧 [EasyGo] 当前选择:', { handleColor, bodyColor, strapColor });

    const updateKey = [handleColor, bodyColor, strapColor]
      .map(function (x) {
        return (x && String(x).trim()) || '';
      })
      .join('|');

    if (updateKey === lastCarrierUpdateKey) {
      if (!isCustomizePage() && isDesktopPdpWith2x2()) {
        hideCarrierOverlay();
        return;
      }
      if (!isCustomizePage() && !isFirstSlideActive()) {
        switchToFirstSlide();
      } else if (!isCustomizePage()) {
        showCarrierOverlay();
      }
      return;
    }

    if (!handleColor || !bodyColor || !strapColor) {
      console.warn('⚠️  [EasyGo] 颜色选项不完整');
      return;
    }

    isUpdating = true;
    lastCarrierUpdateKey = updateKey;

    if (isCustomizePage()) {
      updateCustomizeCarrierCdnImage(handleColor, bodyColor, strapColor);
      return;
    }

    if (isDesktopPdpWith2x2()) {
      hideCarrierOverlay();
      const url = resolveCarrierCdnUrl(handleColor, bodyColor, strapColor);
      if (url) {
        setDesktop2x2VariantCellImage(url, function () {
          isUpdating = false;
        });
      } else {
        isUpdating = false;
      }
      return;
    }

    switchToFirstSlide();
    const url = resolveCarrierCdnUrl(handleColor, bodyColor, strapColor);
    if (url) {
      updateCarrierOverlayImage(url);
    } else {
      isUpdating = false;
    }
  }

  // 显示图片错误提示
  function showImageError(message) {
    let errorOverlay = document.getElementById('easygo-error-overlay');

    if (!errorOverlay) {
      errorOverlay = document.createElement('div');
      errorOverlay.id = 'easygo-error-overlay';
      errorOverlay.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: rgba(220, 38, 38, 0.95);
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        animation: slideInRight 0.3s ease-out;
      `;

      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `;
      document.head.appendChild(style);

      document.body.appendChild(errorOverlay);
    }

    errorOverlay.textContent = message;
    errorOverlay.style.display = 'block';

    setTimeout(() => {
      errorOverlay.style.display = 'none';
    }, 3000);
  }

  // 初始化（与 product-easygo-outdoor-set.js：body 捕获 click/change + .js-product on:variant:change）
  function init() {
    if (!shouldRun()) {
      console.log('⏭️  [EasyGo] 不是目标产品,跳过初始化');
      return;
    }

    console.log('✅ [EasyGo] 开始初始化...');

    if (!document.body.dataset.easygoCarrierBound) {
      document.body.dataset.easygoCarrierBound = 'true';

      let carrierResizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(carrierResizeTimer);
        carrierResizeTimer = setTimeout(function () {
          if (!shouldRun() || isCustomizePage()) return;
          if (isDesktopPdpWith2x2()) {
            hideCarrierOverlay();
          } else {
            syncCarrierOverlayLayout();
          }
        }, 150);
      });

      document.body.addEventListener(
        'click',
        function (e) {
          if (!shouldRun()) return;
          const t = e.target;
          if (!t || !t.closest) return;
          if (
            t.closest('.color-swatch') ||
            t.closest('.text-option') ||
            t.closest('.custom-select__option') ||
            (t.matches && t.matches('input[type="radio"]')) ||
            (t.matches && t.matches('label[for*="option"]'))
          ) {
            console.log('🎨 [EasyGo] 检测到选项点击');
            lastCarrierUpdateKey = '';
            updateProductImage();
          }
        },
        true
      );

      document.body.addEventListener(
        'change',
        function (e) {
          if (!shouldRun()) return;
          const t = e.target;
          const tag = t && t.tagName ? t.tagName.toLowerCase() : '';
          const insideCustomSelect = t && t.closest && t.closest('custom-select');
          if (
            (t.matches && t.matches('select')) ||
            (t.matches && t.matches('input[type="radio"]')) ||
            tag === 'custom-select' ||
            insideCustomSelect
          ) {
            console.log('🎨 [EasyGo] 检测到选项 change（含 custom-select）');
            lastCarrierUpdateKey = '';
            updateProductImage();
          }
        },
        true
      );

      if (!isCustomizePage()) {
        document.body.addEventListener('click', handleCarrierThumbnailClick, false);
        const section = document.querySelector('.js-product');
        if (section) {
          section.addEventListener('on:carousel-slider:select', handleCarrierCarouselSlide);
          section.addEventListener('on:variant:change', function () {
            if (!shouldRun() || isCustomizePage()) return;
            setTimeout(function () {
              lastCarrierUpdateKey = '';
              if (isDesktopPdpWith2x2()) {
                hideCarrierOverlay();
                updateProductImage();
                return;
              }
              switchToFirstSlide();
              setTimeout(showCarrierOverlay, 150);
              updateProductImage();
            }, 200);
          });
        }
      }
    }

    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && !productSelect.dataset.easygoBound) {
        productSelect.dataset.easygoBound = 'true';
        productSelect.addEventListener('change', function () {
          hasLoggedMismatch = false;
          lastCheckedProduct = '';
          lastCarrierUpdateKey = '';
          setTimeout(function () {
            if (shouldRun()) setTimeout(updateProductImage, 500);
          }, 300);
        });
      }

      const optionsWrapper = document.getElementById('product-option-groups');
      if (optionsWrapper && !optionsWrapper.dataset.easygoCarrierObserved) {
        optionsWrapper.dataset.easygoCarrierObserved = 'true';
        const optionsObserver = new MutationObserver(function (mutations) {
          const hasNewNodes = mutations.some(function (m) {
            return m.addedNodes.length > 0;
          });
          if (hasNewNodes) {
            setTimeout(function () {
              if (shouldRun()) {
                lastCarrierUpdateKey = '';
                updateProductImage();
              }
            }, 300);
          }
        });
        optionsObserver.observe(optionsWrapper, { childList: true, subtree: true });
      }
    }

    requestAnimationFrame(function () {
      if (shouldRun() && !isCustomizePage() && isDesktopPdpWith2x2()) hideCarrierOverlay();
    });

    setTimeout(function () {
      if (shouldRun()) {
        lastCarrierUpdateKey = '';
        updateProductImage();
      }
    }, isCustomizePage() ? 500 : 1000);

    console.log('✅ [EasyGo] 初始化完成');
  }

  // 延迟初始化
  function delayedInit() {
    const delay = isCustomizePage() ? 2000 : 500;
    setTimeout(() => {
      if (shouldRun()) {
        init();
      } else if (isCustomizePage()) {
        // Customize 页面再等一次
        setTimeout(() => {
          if (shouldRun()) init();
        }, 2000);
      }
    }, delay);
  }

  // 启动脚本
  if (isCustomizePage() || shouldRun()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', delayedInit);
    } else {
      delayedInit();
    }
  }

  // 暴露全局函数供调试
  window.EasyGoCarrier = {
    updateImage: updateProductImage,
    getOptionValue: getOptionValue,
    getCurrentColor: getCurrentColor,
    getCarrierColors: getCarrierColorsForUpdate,
    generateUrl: generateImageUrl,
    reinit: init,
    test: function (handle, body, strap) {
      console.log('🧪 [TEST] 测试图片URL生成...');
      const url = generateImageUrl(handle, body, strap);
      console.log('URL:', url);
      return url;
    }
  };

  console.log('🎨 EasyGo Pet Carrier 图片系统已加载!');
  console.log('💡 调试命令:');
  console.log('   EasyGoCarrier.updateImage() - 手动更新图片');
  console.log('   EasyGoCarrier.test("Cyan", "Pink", "White") - 测试URL生成');
  console.log('   EasyGoCarrier.getOptionValue(0) - PDP 选项0（Customize 亦可用）');
})();
